import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobApplications } from '../../lib';

function Application(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/application`}>
      {
        <MobApplications weId={`${props.weId || ''}_kj0za7`} />
      }
    </Route>
  )
}

export default withRouter(Application);